import { VistaMGViewType } from '@extras_mg/viewTypeBase'

import KanbanView from '@extras_mg/components/KanbanView'
import KanbanViewHeader from '@extras_mg/components/KanbanViewHeader'
import CalendarioView from '@extras_mg/components/CalendarioView'
import CalendarioViewHeader from '@extras_mg/components/CalendarioViewHeader'
import TimelineView from '@extras_mg/components/TimelineView'
import TimelineViewHeader from '@extras_mg/components/TimelineViewHeader'

/**
 * Vista Kanban.
 *
 * Nombre propio (kanban_mg): la de premium sigue registrada y sigue pidiendo
 * licencia, esta es otra y aparece a su lado en el menu.
 *
 * No usa BaseBufferedRowViewTypeMixin a proposito. Esa maquinaria carga las
 * filas por ventana segun lo que se ve, que para una cuadricula es lo correcto
 * pero para un tablero es un estorbo: para armar las columnas hacen falta todas
 * las filas de todas formas. El componente las pide de una y agrupa; el tope
 * esta puesto y se avisa en pantalla al alcanzarlo.
 */
export class KanbanMGViewType extends VistaMGViewType {
  static getType() {
    return 'kanban_mg'
  }

  getIconClass() {
    return 'baserow-icon-kanban'
  }

  getColorClass() {
    return 'color-success'
  }

  getName() {
    return 'Kanban'
  }

  getHeaderComponent() {
    return KanbanViewHeader
  }

  getComponent() {
    return KanbanView
  }

  canFilter() {
    return true
  }

  canSort() {
    return true
  }

  canShare() {
    return false
  }

  canShowRowModal() {
    return true
  }


  getDefaultFieldOptionValues() {
    // Igual que en KanbanMGViewFieldOptions del backend, para no descuadrar.
    return { hidden: true, order: 32767 }
  }
}

/**
 * Vista de calendario. Mismo criterio que el Kanban: pide las filas de una vez
 * y las coloca en la rejilla del mes, sin la maquinaria de carga por ventana.
 */
export class CalendarioMGViewType extends VistaMGViewType {
  static getType() {
    return 'calendario_mg'
  }

  getIconClass() {
    return 'baserow-icon-calendar'
  }

  getColorClass() {
    return 'color-warning'
  }

  getName() {
    return 'Calendario'
  }

  getHeaderComponent() {
    return CalendarioViewHeader
  }

  getComponent() {
    return CalendarioView
  }

  canFilter() {
    return true
  }

  canSort() {
    return true
  }

  canShare() {
    return false
  }

  canShowRowModal() {
    return true
  }


  getDefaultFieldOptionValues() {
    return { hidden: true, order: 32767 }
  }
}

/**
 * Linea de tiempo. Misma decision de diseño que Kanban y Calendario: las filas
 * se piden de una y el dibujo se hace aqui.
 */
export class TimelineMGViewType extends VistaMGViewType {
  static getType() {
    return 'timeline_mg'
  }

  getIconClass() {
    return 'baserow-icon-timeline'
  }

  getColorClass() {
    return 'color-info'
  }

  getName() {
    return 'Linea de tiempo'
  }

  getHeaderComponent() {
    return TimelineViewHeader
  }

  getComponent() {
    return TimelineView
  }

  canFilter() {
    return true
  }

  canSort() {
    return true
  }

  canShare() {
    return false
  }

  canShowRowModal() {
    return true
  }


  getDefaultFieldOptionValues() {
    return { hidden: true, order: 32767 }
  }
}
